import { RefObject, useEffect, useState } from 'react';

export const useOutsideBlur = (
  wrapper: RefObject<HTMLElement>,
  onOutsideBlur: () => void,
) => {
  const [outside, setOutside] = useState(false);
  const [blur, setBlur] = useState(false);

  useEffect(() => {
    function handleClickOutside(event: any) {
      setOutside(!!wrapper.current && !wrapper.current.contains(event.target));
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapper]);

  useEffect(() => {
    if (outside && blur) onOutsideBlur();
  }, [outside, blur]);

  return { setBlur };
};
